export type environments = 'local' | 'dev' | 'test' | 'uat' | null;

export const envAccess = (env: environments) => {
  const host = location.host;
  let allowedDomains: string[] = [];
  let access = false;

  switch (env) {
    case 'uat':
      allowedDomains = [
        'localhost:4200',
        'scheduler.satcomdev.com',
        'scheduler.satcomtest.com',
        'scheduler.satcomuat.com'
      ];
      break;
    case 'test':
      allowedDomains = ['localhost:4200', 'scheduler.satcomdev.com', 'scheduler.satcomtest.com'];
      break;
    case 'dev':
      allowedDomains = ['localhost:4200', 'scheduler.satcomdev.com'];
      break;
    case 'local':
      allowedDomains = ['localhost:4200'];
      break;
  }

  if (allowedDomains.includes(host)) {
    access = true;
  }

  return access;
};

export const newFeatureEnvAccess = (customerId: string) => {
  const host = location.host;

  let access = false;

  const allowedDomains: string[] = [
    'localhost:4200',
    'scheduler.satcomdev.com',
    'scheduler.satcomtest.com'
  ];

  const uatDomain: string[] = ['scheduler.satcomuat.com'];

  const uatAllowedCustomerIds: string[] = ['15292', '15316'];

  const prodAllowedCustomerIds: string[] = ['15292', '15316', '15364'];

  if (allowedDomains.includes(host)) {
    access = true;
  } else if (uatDomain.includes(host)) {
    if (customerId.length > 0 && uatAllowedCustomerIds.includes(customerId)) {
      access = true;
    }
  } else if (customerId.length > 0 && prodAllowedCustomerIds.includes(customerId)) {
    access = true;
  }

  return access;
};
